// extracted by mini-css-extract-plugin
module.exports = {"container":"attachment-image_container__61ttp"};